import _ from 'lodash';
import { useParams } from 'react-router';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useTypedFastStorage } from '../../../hooks/useFastStorage';
import useFunctionKeys from '../../../hooks/useFunctionKeys';
import useGlobalOkDialog from '../../../hooks/useGlobalOkDialog';
import ApplicationContext from '../../../ApplicationContext';
import CloseButton from '../../../ui/CloseButton';
import { JobNames } from '../../../framework.core/JobNames';
import { AcctDetail } from '../../../fms.core/AcctDetail';
import BTOrderBillingsDetails from './implementation/BTOrderBillingsDetails';
import constants from '../../../constants';
import useJobMenu from '../../../hooks/useJobMenu';
import useDirtyCheck from '../../../hooks/useDirtyCheck2';
import { ApiResult } from '../../../framework.core/data/ApiResult';
import { BtOrder } from '../../../fms.core/BtOrder';
import { getTooltipValue } from '../../../util';
import { SalesCostSummary } from '../../common/SalesCostEntry';

// interface BillingInfoStorageKeys {
//   modelStorage: string,
// };

interface SummaryStorageKeys {
  modelSummaryStorage: string,
};

interface BillingBtoInfoStorageKeys {
  modelBtoStorage: string
};

interface BTOrderBillingsViewParams {
  id: string | undefined,
};

interface BillingInfoLoadedParams {
  // billingInfo: Array<AcctDetail>,
  btOrderInfo: BtOrder,
  close: () => {},
  summary: SalesCostSummary,
};

function BTOrderBillingsDetailsImpl(params: BTOrderBillingsViewParams) {
  const id = useRef(params.id);
  const title = 'View Billings';

  // const { modelStorage } = getBillingInfoStorageKeys(id.current);
  const { modelBtoStorage } = getBtoStorageKeys(id.current);
  const { modelSummaryStorage } = getSummaryStorageKeys(id.current);

  const {
    goBack
  } = useJobMenu(title, constants.operations.order, null, true, cleanup);

  const { dirtyCleanup } = useDirtyCheck(modelBtoStorage, ['updated', 'updatedBy']);

  // const [inStorage, setInStorage, , ] = useTypedFastStorage<Array<AcctDetail>>(modelStorage, null);
  const [btoInStorage, setBtoInStorage, , ] = useTypedFastStorage<BtOrder>(modelBtoStorage, null);
  const [summaryStorage, setSummaryStorage, , ] = useTypedFastStorage<SalesCostSummary>(modelSummaryStorage, {
      billSummary: [],
      invoiceSummary: [],
      crdbSummary: [],
    });

  const appContext = useContext(ApplicationContext);

  const [initialized, setInitialized] = useState(false);

  const [showGlobalOkDialog] = useGlobalOkDialog();
  useEffect(() => {
    initialize();
  },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  useEffect(() => {
    //If initialized is true, then form's tab button is active
    const activeClass = appContext.useDarkMode ? 'e-job-btn-active-darkmode' : 'e-job-btn-active';
    const activeTabButton = document.getElementsByClassName(activeClass)[0] as HTMLInputElement;
    if (activeTabButton && btoInStorage) {
      activeTabButton.dataset.tooltip = getTooltipValue(btoInStorage['orderNo'], JobNames.BTOrder);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialized]);

  // function getBillingInfoStorageKeys(id: string | undefined): BillingInfoStorageKeys {
  //   return { modelStorage: `common-billinginfo-bto-view${id}` }
  // }
  function getBtoStorageKeys(id: string | undefined): BillingBtoInfoStorageKeys {
    return { modelBtoStorage: `common-billinginfo-btodetail-view${id}` }
  }
  function getSummaryStorageKeys(id: string | undefined ): SummaryStorageKeys {
    return { modelSummaryStorage: `common-summary-btodetail-view${id}` }
  }

  function cleanup() {
    dirtyCleanup();
  }

  function close() {
    goBack();
    return true;
  }

  // async function loadBillingData() {
  //   const apiResult = await appContext.api.getJobAcctDetails(JobNames.BTOrder, Number(id.current));

  //   if (!apiResult) {
  //     await showGlobalOkDialog(<p>Manifest billings not found</p>,false,null,'warning');
  //     goBack();
  //     return false;
  //   }
  //   setInStorage(apiResult);

  //   return true;
  // }

  async function loadOthData() {
    const apiResult: ApiResult<BtOrder> = await appContext.api.getJobDetail(JobNames.BTOrder, { id: id.current });
    if (!apiResult || !apiResult.success) {
      await showGlobalOkDialog(apiResult ? <p>{apiResult.message}</p> : <p>Manifest not found</p>,false,null,'warning');
      goBack();
      return false;
    }
    const btorder = new BtOrder(apiResult.result); //save-sqlinfo
    setBtoInStorage(_.cloneDeep(btorder));

    return true;
  }

  async function initializeSummary() {
    const apiResult = await appContext.api.getJobSalesCostSummary(JobNames.BTOrder, id.current);
  
    if (apiResult && apiResult.success) {
      setSummaryStorage(apiResult.result);
    } 
  }

  async function initialize() {
    if (!btoInStorage) {
      await loadOthData();
      await initializeSummary();
    }

    setInitialized(true);
  }

  if (!initialized || !btoInStorage || !summaryStorage) {
    return null;
  }

  return (
    <BillingInfoInitializedImpl
      close={close}
      // billingInfo={inStorage}
      btOrderInfo={btoInStorage}
      summary={summaryStorage}
    />
  );
}

function BillingInfoInitializedImpl({
  // billingInfo,
  btOrderInfo,
  summary,
  close,
}: BillingInfoLoadedParams) {

  useFunctionKeys({ onEsc: cancel });

  function cancel() {
    const modals = document.querySelectorAll('[class^="ReactModal__Content"]');
    if (modals.length > 0) {
      return false;
    }
    
    close();
    return true;
  }

  return (
    <BTOrderBillingsDetails
      commands={
        <>
          <div className="ifms-left-separator-light-gray" />
          <div className="ifms-common-bar-element">
            <CloseButton mode='light' onClick={cancel} />
          </div>
        </>
      }
      // billingInfo={billingInfo}
      summary={summary}
      btOrderInfo={btOrderInfo}
    />
  );
}

const BTOrderBillingsView = () => {
  const { id } = useParams<BTOrderBillingsViewParams>();

  /**
   * Implementation note:
   *   key is important in this case in order to force full List view rerender for different parameters.
   */
  return (
    <BTOrderBillingsDetailsImpl id={id} key={`bto-${id}-billings`}/>
  );
};
export default BTOrderBillingsView;
